<script>
    import WPNItemsTable from "../Misc/WPNItemsTable.svelte";
    import ModalButtons from "../Modal/ModalButtons.svelte";
    import { associatedItemsForEntities } from "../../scripts/wpn2Model.js";
    import { protoItemFromProperties } from "../../scripts/wpn2Edit.js";
    import dbData from "../../Stores/utilityDBStore.js";

    export let selectedItem = null;
    export let editedNote = null;
    let cellButtonTypes = ["Edit", "Remove"];
    let noteItems;

    $: noteItems = associatedItemsForEntities(['Note'], $dbData.all, item, false, false, true, false);

    function saveNote() {
        console.log("Saving edited note");
    }

    function editNewNote() {
        const props = { entity: "Note", wpn2_type: "Note" };
        editedNote = protoItemFromProperties(props, $dbData, $dbData.user_item);
        console.log("New note: ", editedNote);
    }
    // TODO: Text Area is not editable and buttons are on same row
</script>

{#if editedNote != null}
    <div class="center-editor">
        <div>
            <textarea>{editedNote["note_text"]}</textarea>
        </div>
        <div>
            <ModalButtons
                actions={["cancel", "save"]}
                on:cancel={() => (editedNote = null)}
                on:save={saveNote}
            />
        </div>
    </div>
{:else}
    <div class="edit-container">
        <div class="edit-section-title">Notes</div>
        {#if noteItems.length == 0}
            <p class="edit-related-statement">
                {"There are no notes for " + selectedItem.name ?? selectedItem.wpn2_type + "."}
            </p>
        {/if}
        {#if noteItems.length > 0}
            <div class="table-container">
                <WPNItemsTable
                    items={{author: "John Doe", date: "today"}}
                    tableType="NotesTable"
                    {cellButtonTypes}
                    on:item-edit
                    on:item-remove
                />
            </div>
        {/if}
        <div class="add-button-view">
            <button class="edit-add-button" on:click={editNewNote}>
                Add Note
            </button>
        </div>
    </div>
{/if}

<style>
    .center-editor {
        position: relative;
        margin: auto;
        max-width: max-content;
        min-width: 440px;
        max-height: 440px;
        font-family: "Source Sans Pro", sans-serif;
        font-size: 0.8rem;
        line-height: 1;
        background-color: #fff;
        border: solid 3px #cfc5c5;
        overflow: scroll;
    }
</style>
